export default __webpack_public_path__ + "static/media/ChristmasCheer.79a52ae3.png";